import React, { useState, useEffect } from 'react';
import { useStyles, StyledTableCell } from '../../adminStyles';
import { useDispatch, useSelector } from 'react-redux';
import { getJobTitles, getClientManagers ,saveClientManager} from '../../../../redux/appUsers/appUserActions';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Button,
  Grid,
  TableContainer,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

const UserTable = props => {
  const jobTitles = useSelector(state => state.appUsers.jobTitles || []);
  const users = useSelector(state => state.appUsers.usersList);
  const dispatch = useDispatch();
  const [del, setDel] = useState({ open: false, id: 0 });
  const {
    tableRoot,
    sortLabel,
    tableCell,
    tableContainer,
    iconCell,
    dialogTitle,
  } = useStyles();

  const {
    rows,
    sortArray,
    orderAscending,
    orderBy,
    asc,
    searchTerm,
    currentUser,
  } = props;

  const handleClose = () => setDel({ open: false, id: 0 });
  const bindUsers = () => dispatch(getClientManagers());

  const handleOk = async() => {
    const uid = del.id;
    setDel({ open: false, id: 0 });
    let record = {};
    record = rows.filter(row => row.id == uid)[0] || {};
    if(Object.keys(record).length!==0){
      record['active']=0;
     let res = await dispatch(saveClientManager(record));
     if(res)
      dispatch(getClientManagers());
    }
  };

  useEffect(() => {
    bindUsers();
  }, []);

  const getUserJobTitle = id => {
    let job = jobTitles.find(job => {
      return job.id === id;
    });
    if (job) {
      return job.jobTitle;
    }
    return 'N/A';
  };

  const getUserManager = id => {
    let manager = users.find(user => {
      return user.id === id;
    });
    if (manager) {
      return `${manager.firstName} ${manager.lastName}`;
    }
    return 'N/A';
  };

  const renderStyledTableCell = () => {
    return (
      <>
        <StyledTableCell
          key={'id'}
          align={'center'}
          padding={'default'}
          sortDirection={orderBy === 'id' ? orderAscending : false}
        >
          <TableSortLabel
            active={orderBy === 'id'}
            direction={asc}
            onClick={sortArray(rows, 'id')}
            className={sortLabel}
          >
            Emp.Id
          </TableSortLabel>
        </StyledTableCell>
        <StyledTableCell
          key={'name'}
          align={'center'}
          padding={'default'}
          sortDirection={orderBy === 'name' ? orderAscending : false}
        >
          <TableSortLabel
            active={orderBy === 'name'}
            direction={asc}
            onClick={sortArray(rows, 'name')}
            className={sortLabel}
          >
            Name
          </TableSortLabel>
        </StyledTableCell>
        <StyledTableCell
          key={'contact'}
          align={'center'}
          padding={'default'}
          sortDirection={orderBy === 'name' ? orderAscending : false}
        >
          <TableSortLabel
            active={orderBy === 'name'}
            direction={asc}
            onClick={sortArray(rows, 'name')}
            className={sortLabel}
          >
            Contact
          </TableSortLabel>
        </StyledTableCell>
        <StyledTableCell
          key={'active'}
          align={'center'}
          padding={'default'}
          sortDirection={orderBy === 'active' ? orderAscending : false}
        >
          <TableSortLabel
            active={orderBy === 'active'}
            direction={asc}
            onClick={sortArray(rows, 'aactive')}
            className={sortLabel}
          >
            status
          </TableSortLabel>
        </StyledTableCell>
        {currentUser.role === 'manager' ? null : (
          <StyledTableCell key={'action'} align={'center'} padding={'default'}>
            Action
          </StyledTableCell>
        )}
      </>
    );
  };

  const transformedRows = () => {
    return rows.map(row => {
      return { ...row};
    });
  };

  const renderTableContent = () => {
    return (
      <>
        {transformedRows &&
          transformedRows()
            .filter(
              row =>
                ((row.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
                  (row.id || '').toString().toLowerCase().includes(searchTerm.toLowerCase())||
                  (row.emailId || '').toLowerCase().includes(searchTerm.toLowerCase()))
            )
            .map((row, i) => {
              return (
                <TableRow tabIndex={-1} key={i}>
                  <TableCell key={i + '-0'} align={'left'} className={tableCell}>
                    {row.id}
                  </TableCell>
                  <TableCell key={i + '-1'} align={'left'} className={tableCell}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <label
                          style={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                          }}
                        >
                          {row.name}
                        </label>
                      </Grid>
                    </Grid>
                  </TableCell>
                  <TableCell key={i + '-2'} align={'left'} className={tableCell}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <b>{'Email: '}</b>
                        <span>{row.emailId|| ''}</span>
                      </Grid>
                     </Grid>
                  </TableCell>
                  <TableCell key={i + '-2'} align={'left'} className={tableCell}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <b>{'Status: '}</b>
                        <span>{row.active==1?'Active':'Deactive'}</span>
                      </Grid>
                     
                    </Grid>
                  </TableCell>
                  {currentUser.role === 'manager' ? null : (
                    <TableCell key={i + '-4'} align={'left'} className={tableCell}>
                      <div className={iconCell}>
                        <IconButton
                          color='primary'
                          size='small'
                          onClick={() => {
                            props.history.push(`/admin/externaldetails/${row.id}`);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        {props.activeRecords ? (
                          <IconButton
                            color='primary'
                            size='small'
                            onClick={() => {
                              setDel({
                                open: true,
                                id: `${row.id}`,
                              });
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        ) : null}
                      </div>
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
      </>
    );
  };

  return (
    <>
      <Paper className={tableRoot}>
        <TableContainer className={tableContainer}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>{renderStyledTableCell()}</TableRow>
            </TableHead>
            <TableBody>{renderTableContent()}</TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Dialog
        open={del.open}
        onClose={handleClose}
        aria-labelledby='draggable-dialog-title'
      >
        <DialogTitle id='draggable-dialog-title'>
          <Typography variant='h5' className={dialogTitle}>
            Confirmation For Deactivate User
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to Deactivate the user?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color='primary'>
            Cancel
          </Button>
          <Button onClick={handleOk} color='primary'>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserTable;
